// The console's Dashboard route now renders the Hiring dashboard
// (headline tiles, candidate journey, role coverage, act-now), replacing the
// old hardcoded placeholder. Kept as a thin wrapper so the /dashboard route
// and its imports stay stable.
import React from 'react';
import HiringDashboard from '../../features/dashboard/HiringDashboard';

const DashboardPage = () => <HiringDashboard />;

export default DashboardPage;
